export class AssistanceStatus {
  public static readonly Activated = 'Activated';
  public static readonly RenewalProduced = 'Renewal Produced';
  public static readonly ReminderProduced = 'Reminder Produced';
  public static readonly PendingPayment = 'Pending Payment';
  public static readonly Lapsed = 'Lapsed';
  public static readonly Expired = 'Expired';
}

/**
 * Status returned by OSAPI on currentProduct.status used to differentiate
 * the "Payment due" vs "Renewal due" call-out label on Make a Payment.
 */
export class PaymentProductStatus {
  public static readonly InRenewal = 'InRenewal';
  public static readonly RenewalProduced = 'Renewal Produced';
  public static readonly ReminderProduced = 'Reminder Produced';
  public static readonly Active = 'Active';
  public static readonly Overdue = 'Overdue';
  public static readonly Cancelled = 'Cancelled';
}
